var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"common"}},[_vm._v(" common "),_c('router-link',{attrs:{"to":"/self/settings/common/language"}},[_vm._v("language设置")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }